import JSZip from 'jszip'
import { saveAs } from 'file-saver'

/**
 * @description 单个下载文件
 * @param blob Blob对象
 * @param filename 文件名称
 * @param suffix 后缀名
 */
export function download(blob, filename, suffix) {
  if (!(blob instanceof Blob) && typeof blob !== 'string') {
    throw new Error("参数 'blob' 应为 Blob 对象 或者 字符串")
  }

  if (typeof filename !== 'string' || filename === '') {
    throw new Error("参数 'filename' 应为非空字符串")
  }

  if (typeof suffix !== 'string' || suffix === '') {
    throw new Error("参数 'suffix' 应为非空字符串")
  }
  const fullFilename = `${filename}.${suffix}`
  saveAs(blob, fullFilename)
}

/**
 * @description 执行单张下载
 * @param files
 * @returns {Promise<void>}
 */
export async function singleDownload(files) {
  if (!Array.isArray(files) || files.length <= 0) {
    return
  }
  for (let i = 0; i < files.length; i++) {
    const file = files[i]
    if (
      (!(file.raw instanceof Blob) && typeof file.raw !== 'string') ||
      typeof file.filename !== 'string' ||
      typeof file.suffix !== 'string'
    ) {
      throw new Error(`文件 #${i + 1} 参数不符合要求`)
    }

    const fullFilename = `${file.filename}.${file.suffix}`
    if (typeof file.raw === 'string') {
      // 如果是远程 URL 地址，使用 fetch 来下载文件内容
      fetch(file.raw)
        .then(response => response.blob())
        .then(blob => {
          saveAs(blob, fullFilename)
        })
    } else {
      saveAs(file.raw, fullFilename)
    }
  }
}

/**
 * 递归下载多张图片，绕过浏览器并发限制
 * @param {Array} imageUrls - 图片URL数组
 * @param {number} [delay=300] - 下载间隔时间(毫秒)
 * @param {number} [batchSize=5] - 每批下载数量
 */
function downloadImagesRecursively(imageUrls, delay = 300, batchSize = 5) {
  // 创建下载链接并触发点击的函数
  function downloadImage(file, index) {
    return new Promise((resolve) => {
      setTimeout(() => {
        if (
          (!(file.raw instanceof Blob) && typeof file.raw !== 'string') ||
          typeof file.filename !== 'string' ||
          typeof file.suffix !== 'string'
        ) {
          throw new Error(`文件 #${index + 1} 参数不符合要求`)
        }

        const fullFilename = `${file.filename}.${file.suffix}`
        if (typeof file.raw === 'string') {
          // 如果是远程 URL 地址，使用 fetch 来下载文件内容
          fetch(file.raw)
            .then(response => response.blob())
            .then(blob => {
              saveAs(blob, fullFilename)
            })
        } else {
          saveAs(file.raw, fullFilename)
        }

        // 使用setTimeout确保下载触发后再继续
        setTimeout(resolve, 100);
      }, 0);
    });
  }

  // 递归下载函数
  async function downloadBatch(startIndex) {
    if (startIndex >= imageUrls.length) return;

    const endIndex = Math.min(startIndex + batchSize, imageUrls.length);
    const batch = imageUrls.slice(startIndex, endIndex);

    // 并行下载当前批次
    await Promise.all(batch.map((url, i) => downloadImage(url, startIndex + i)));

    // 延迟后下载下一批
    setTimeout(() => {
      downloadBatch(endIndex);
    }, delay);
  }

  // 开始下载
  downloadBatch(0);
}




/**
 * @description 批量下载
 * @param files
 * @returns {Promise<void>}
 */
export async function batchDownload(files) {
  if (!Array.isArray(files) || files.length <= 0) {
    return
  }
  downloadImagesRecursively(files, 500, 3); // 每次下载3张，间隔500ms
  for (let i = 0; i < files.length; i++) {
    // const file = files[i]
    // if (
    //   (!(file.raw instanceof Blob) && typeof file.raw !== 'string') ||
    //   typeof file.filename !== 'string' ||
    //   typeof file.suffix !== 'string'
    // ) {
    //   throw new Error(`文件 #${i + 1} 参数不符合要求`)
    // }
    //
    // const fullFilename = `${file.filename}.${file.suffix}`
    // if (typeof file.raw === 'string') {
    //   // 如果是远程 URL 地址，使用 fetch 来下载文件内容
    //   fetch(file.raw)
    //     .then(response => response.blob())
    //     .then(blob => {
    //       saveAs(blob, fullFilename)
    //     })
    // } else {
    //   saveAs(file.raw, fullFilename)
    // }
  }
}

/**
 * @description 批量下载
 * @param files
 * @returns {Promise<void>}
 */
export async function batchDownloadZip(files) {
  if (!Array.isArray(files) || files.length <= 0) {
    return
  }
  const zip = new JSZip()
  const fetchPromises = []
  for (let i = 0; i < files.length; i++) {
    const file = files[i]
    if (
      (!(file.raw instanceof Blob) && typeof file.raw !== 'string') ||
      typeof file.filename !== 'string' ||
      typeof file.suffix !== 'string'
    ) {
      throw new Error(`文件 #${i + 1} 参数不符合要求`)
    }

    const fullFilename = `${file.filename}.${file.suffix}`
    const chinaTime = new Date(new Date().getTime() + 8 * 60 * 60 * 1000)
    if (typeof file.raw === 'string') {
      // 如果是远程 URL 地址，使用 fetch 来下载文件内容
      const fetchPromise = fetch(file.raw)
        .then(response => response.blob())
        .then(blob => {
          zip.file(fullFilename, blob, { binary: true, date: chinaTime })
        })
      fetchPromises.push(fetchPromise)
    } else {
      zip.file(fullFilename, file.raw, { binary: true, date: chinaTime })
    }
  }
  await Promise.all(fetchPromises) // 等待所有远程文件下载完成

  const zipBlob = await zip.generateAsync({ type: 'blob' })
  saveAs(zipBlob, '轻秒图片转换器.zip')
}
